import 'react-leaflet-fullscreen/dist/styles.css';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import FullscreenControl from 'react-leaflet-fullscreen';

export default FullscreenControl;
